export default __webpack_public_path__ + "static/media/images-search.69ba4bdb.png";